
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Control } from '@/__env/lib/Expedicion/Control';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public Seleccionado: number = 0;
        public get SeleccionadoReal()
        {
            return this.Items.findIndex( x => x.Id == this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Id );
        };
        public Cargando: string = 'ninguno';
        public CodigoAleatorio: string = 'ninguno';

        public get Items()
        {
            let ii: { Id?: string, Tipo: 'opcion' | 'titulo'; Icono?: string; Titulo?: string; Accion?: Function; Desactivado?: boolean; }[] = [];

            ii.push( { Tipo: 'titulo', Titulo: '' } );

            if ( this.Controlador.EdicionPedido.Iniciado )
            {
                ii.push( { Id: "1", Tipo: 'opcion', Icono: 'receipt', Titulo: 'Facturar', Accion: this.Facturar } );
                ii.push( { Id: "2", Tipo: 'opcion', Icono: 'cash-register', Titulo: 'Enviar a la caja', Accion: this.EnviarAlaCaja } );
                ii.push( { Id: "3", Tipo: 'opcion', Icono: 'factory', Titulo: 'Enviar a preparar', Accion: this.EnviarAPreparar } );
                ii.push( { Tipo: 'titulo', Titulo: '' } );
                ii.push( { Id: "4", Tipo: 'opcion', Icono: 'content-save', Titulo: 'Guardar', Accion: this.Guardar } );
            }

            ii.push( { Tipo: 'titulo', Titulo: '' } );
            ii.push( { Id: "5", Tipo: 'opcion', Icono: 'exit-run', Titulo: 'Cancelar', Accion: this.Salir } );

            return ii;
        }

        Facturar() { this.Controlador.Vista.BarraIzquierda.Modo = 'articulo'; }
        EnviarAlaCaja() { this.Controlador.Vista.BarraIzquierda.Modo = 'articulo'; }
        EnviarAPreparar() { this.Controlador.Vista.BarraIzquierda.Modo = 'articulo'; }


        Guardar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';
        }

        Salir()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
        }


        async DescargarNotaDeVenta( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLNotaDeVenta( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la nota de venta` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';

        }
        async DescargarTicket( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLNotaDeVenta( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la nota de venta` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';
        }
        async DescargarPresupuesto( item: string )
        {
            this.Cargando = item;
            if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
            {
                let e = await this.Controlador.Guardar();
                if ( !e )
                {
                    Utiles.Notificaciones.Error( `Error al guardar el pedido` );
                    return;
                }
            }

            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLPresupuesto( [this.Controlador.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar el archivo` );

            }

            Utiles.GenerandoArchivo( false );
            this.Cargando = 'ninguno';
        }
        async ImprimirEtiquetas()
        {
            let e = await this.Controlador.Guardar();
            if ( e )
            {
                //let pdf = await Pedido.URLEtiquetasItems( [this.Controlador.Pedido] );
                //if ( pdf )
                //{
                //
                //} else
                //{
                //    Utiles.Notificaciones.Error( `Error al generar la nota de venta` );
                //
                //}
            } else
            {
                Utiles.Notificaciones.Error( `Error al guardar el pedido` );
            }

        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }
        public Problemas: string[] = [];
        async created()
        {
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        async mounted()
        {
            this.Problemas = await this.Controlador.EdicionPedido.ComprobarErrores();
            if ( !this.Problemas.hasRows() )
            {
                await this.Controlador.Pedido.cargarCodigoAleatorio();
                this.CodigoAleatorio = this.Controlador.Pedido.CodigoAleatorio;
            }
        }

        async RefrescarCodigo()
        {
            if ( !this.Problemas.hasRows() )
            {
                await this.Controlador.Pedido.cargarCodigoAleatorio(true);
                this.CodigoAleatorio = this.Controlador.Pedido.CodigoAleatorio;
            }
        }

        onKeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'Tab', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( this.Cargando != 'ninguno' ) return;

            if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'PageUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Items.filter( x => x.Tipo == 'opcion' ).length - 1 );
            }
            else if ( e.key == 'Escape' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado] )
                {
                    this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Accion( this.Items.filter( x => x.Tipo == 'opcion' )[this.Seleccionado].Id );
                }
            }
        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items.filter( x => x.Tipo == 'opcion' )[x] )
            {
                this.Seleccionado = x;
                //console.log( this.Seleccionado, this.isVisibleLista( this.Seleccionado )  );
                //if ( !this.isVisibleLista( this.Seleccionado ) )
                this.ScrollToItemLista();
            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 150,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            console.log( elTop, el.height(), elBottom, winBottom );
            return ( elBottom <= winBottom );
        }
        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
        }





    }
